"use client";

import { ErrorBoundary } from "@datadog/browser-rum-react";
import { Alert, Button, Space } from "antd";
import type { ComponentType, ReactNode } from "react";

type FallbackProps = {
  error: Error;
  resetError: () => void;
};

function DefaultFallback({ error, resetError }: FallbackProps) {
  return (
    <div className="p-4">
      <Alert
        type="error"
        showIcon
        title="Something went wrong"
        description={
          <Space orientation="vertical" className="w-full">
            <span className="text-ink-secondary text-13">{String(error?.message ?? error)}</span>
            <Button size="small" onClick={resetError}>
              Retry
            </Button>
          </Space>
        }
      />
    </div>
  );
}

export default function DatadogErrorBoundary({
  children,
  fallback,
}: {
  children: ReactNode;
  fallback?: ComponentType<FallbackProps>;
}) {
  return <ErrorBoundary fallback={fallback ?? DefaultFallback}>{children}</ErrorBoundary>;
}
